日期选择框，可用于身份证有效期等，如用身份证有效期去加个长期勾选框

<template>
  <el-form-item :label="title" :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="itemClass" v-if="isShow"
    :prop="field.FIELD_ID" :rules="rules">
    <div class="date">
      <el-date-picker :editable="false" :popper-class="field.popperClass" v-model="field.DEFAULT_VALUE"
        :disabled="isDisabled || longTime" type="date" value-format="yyyyMMdd" :picker-options="pickerOptions" :id="field.FIELD_ID"
        @focus="dateInputFocus"></el-date-picker>
      <el-checkbox v-model="longTime" :disabled="isDisabled || disabledLong" v-if="isShowLong" border>长期</el-checkbox>
    </div>
  </el-form-item>
</template>

<script>
import validateRules from "./validateRules";
export default {
  data () {
    return {
      itemClass: "self-datePick",
      longTime: false,
      disablePast: this.field.VALID_TYPE.indexOf("end") != -1,
      disableFuture: (this.field.VALID_TYPE.indexOf("begin") != -1 || this.field.VALID_TYPE.indexOf("birthday") != -1),
      during: this.field.VALID_TYPE.indexOf("during") != 1,
      isDisabled: false,
      triggerType: "custom",
      rules: [],
      pickerOptions: {
        disabledDate: null
      }
    };
  },
  props: ["field", "index", "isBaseUI"],
  created () {
    if (this.field.DEFAULT_VALUE == "0") {
      this.field.DEFAULT_VALUE = "";
    }
    this.rules.push({ validator: this.validatorField, trigger: this.triggerType });
  },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;

    if (this.isRequired)
      this.itemClass += " self-datePick-required";

    if (this.isShowChange)
      this.itemClass += " self-datePick-changed";

    if (this.isShowLong)
      this.itemClass += " self-datePick-showlong";

    this.initData();
  },
  computed: {
    title: function () {
      this.field.FIELD_TITLE = this.field.FIELD_TITLE.replace("\\n", "\n");
      return _.trim(this.field.FIELD_TITLE) ? this.field.FIELD_TITLE
        + (_.intersection(this.field.FIELD_TITLE.split(""), ["：", ":"]).length ? "" : "：") : "";
    },
    isRequired: function () {
      return parseInt(this.field.FIELD_REQUIRED) ? true : false;
    },
    isShowLong: function () {
      return this.field.VALID_TYPE.indexOf("end") != -1 || this.field.showLong;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }

      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
    messageChange: function () {
      return this.field.message;
    },
    dataChange: function () {
      return this.field.DEFAULT_VALUE;
    },
    isShowChange: function () {
      return this.field.showchange;
    },
    disabledLong: function () {
      return this.field.disabledLong;
    }
  },
  methods: {
    initData () {
      if (this.disablePast) {
        let d = (Date.now() - 86400000);
        this.pickerOptions.disabledDate = function (time) {
          return time.getTime() < d;
        };
      } else if (this.disableFuture) {
        let d = Date.now();
        this.pickerOptions.disabledDate = function (time) {
          return time.getTime() > d;
        };
      } else if (this.during) {
        let left = parseInt(this.field.VALID_TYPE.slice(7, 8));
        let right = parseInt(this.field.VALID_TYPE.slice(9, 10));
        let d = (new Date()).getTime();
        let pass = left * 30 * 24 * 3600 * 1000;
        let future = right * 30 * 24 * 3600 * 1000;
        this.pickerOptions.disabledDate = function (time) {
          return time.getTime() > (d + future) || time.getTime() < (d - pass);
        };
      }

      if (this.field.DEFAULT_VALUE == "30001231") {
        this.longTime = true;
      } else {
        this.longTime = false;
      }
    },
    validatorField: function (rule, value, callback) {
      //隐藏的字段不校验
      // if(!this.isShow){
      //   return;
      // }
      value = this.field.DEFAULT_VALUE;
      if (_.trim(value) === "" && this.isRequired && this.isShow) {
        if (this.field.FIELD_NEED_CHECK_EMPTY) { // 字段需要校验空值 触发FIELD_FUNCTION
          this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, {
            field_id: this.field.FIELD_ID,
            module_id: this.field.MODULE_ID,
            index: this.index
          });
        }
        // this.showErrorMsg = this.field.FIELD_TITLE + "为必填项";
        this.showErrorMsg = this.field.CUSTOM_ERR_MESSAGE || this.field.FIELD_TITLE + "为必填项"; // 如字段有CUSTOM_MESSAGE则展示
        this.field.correct = false;
        this.field.showerr = true;
        this.field.FIELD_CONTROL = "0";
        return callback(new Error(this.showErrorMsg));
      } else if (this.field.message) { // 关联逻辑判断中传过来要显示的message
        this.showErrorMsg = this.field.message;
        this.field.correct = false;
        this.field.showerr = true;
        return callback(new Error(this.showErrorMsg));
      } else {
        let isError, msg;
        if (this.field.VALID_TYPE && value) {
          let vTypes = this.field.VALID_TYPE.split("|");
          let vType = _.filter(vTypes, v => !["end", "during", "birthday", "begin"].includes(v));
          vType = vType && vType[0] || "";
          if (vType) {
            let rule = vType in validateRules ? validateRules[vType] : false;
            isError = !rule.valid(value);
            msg = rule.msg;
          }
        }
        if (isError) {
          this.showErrorMsg = msg;
          this.field.message = msg;
          this.field.correct = false;
          this.field.showerr = true;
          return callback(new Error(this.showErrorMsg));
        } else {
          this.field.correct = true;
          this.showErrorMsg = "";
          this.field.message = "";
          this.field.showerr = false;
          if (this.isBaseUI) {
            this.$emit("field-change", this.field);
          } else {
            this.$store.commit(this.$types.UPDATE_FIELD_CHANGE, { field_id: this.field.FIELD_ID, module_id: this.field.MODULE_ID, index: this.index });
          }
          return callback();
        }
      }
    },
    // 日期获取焦点后首先展示年份选择面板 @zhaoyr
    dateInputFocus () {
      let $child = this.$refs[this.field.FIELD_ID].$children || [];
      this.$nextTick(() => {
        if ($child.length) {
          let $picker = _.find($child, function (child) { return typeof child.picker != "undefined"; });
          $picker && $picker.picker.showYearPicker();
        }
      });
    }
  },
  watch: {
    isRequired: function (val) {
      if (val) {
        this.itemClass += " self-datePick-required";
      } else {
        this.itemClass = this.itemClass.replace(/self-datePick-required/g, "");
      }
    },
    isShowChange: function (val) {
      if (val) {
        this.itemClass += " self-datePick-changed";
      } else {
        this.itemClass = this.itemClass.replace(/self-datePick-changed/g, "");
      }
    },
    dataChange: {
      handler (newVal, oldVal) {
        //ocr识别回填字段时，会监听到，但是不需要去除ocr标识
        if(oldVal){
          //如果输入框中的值发生变化，ocr标识消失
          this.field.DATA_SOURCE = 0;
        }
        this.initData();
        this.field.message = "";
        this.$refs[this.field.FIELD_ID] && this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
      },
    },
    messageChange: function (val) {
      this.$refs[this.field.FIELD_ID] && this.$refs[this.field.FIELD_ID].validate("custom"); // 自定义触发校验事件
    },
    longTime: function (val) {
      if (val) {
        this.field.DEFAULT_VALUE = "30001231";
      } else if (this.field.DEFAULT_VALUE == "30001231") {
        // let d = new Date();
        // let month = d.getMonth() < 10 ? "0" + (d.getMonth() + 1) : (d.getMonth() + 1)
        // let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        // let date = d.getFullYear() + month + day + "";
        //取消长期则显示当前日期
        //取消长期则显示空
        this.field.DEFAULT_VALUE = "";
      }
    },
    "field.DATA_SOURCE": {
      handler (val, oldVal) {
        this.itemClass = this.itemClass.replace("ocrIcon","");
        this.itemClass = this.itemClass.replace("zzIcon","");
        this.itemClass = this.itemClass.replace("zdIcon","");
        if (val == "1") {
          this.itemClass += " ocrIcon";
        } else if (val == "2") {
          this.itemClass += " zzIcon";
        } else if (val == "3") {
          this.itemClass += " zdIcon";
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="less">
.self-datePick {
  width: 100%;
  display: flex;
  .el-form-item__label {
    font-size: 14px;
    min-width: 170px;
    text-align: right;
  }
  .el-form-item__content {
    font-size: 14px;
    color: #000;
    flex: 1;
    .date {
      display: inline-flex;
      width: 100%;
      position: relative;
      .el-date-editor {
        display: inline-flex;
        flex: 1;
        width: auto;
        .el-input__inner {
          padding-left: 20px;
        }
        .el-input__prefix {
          left: inherit;
          right: 2px;
          top: 2px;
          .el-input__icon { //日期小组件
            // width: 100%;
            // display: inline-flex;
            // align-items: center;
            // justify-content: center;
            // &::before {
            //   content: "";
            //   display: block;
            //   width: 26px;
            //   height: 24px;
            //   background: url("~@img/material/unusual/icon_rili_nor.png");
            // }
          }
        }
        .el-input__suffix {
          // right: 68px;
          right: 40px;
        }
        &.is-disabled {
          .el-input__prefix {
            .el-input__icon {
              line-height: .4rem;
              &::before {
                // background: url("~@img/material/unusual/icon_rili_dis.png");
              }
            }
          }
        }
      }
      .el-checkbox {
        border: none;
        flex: 0 0 60px;
        display: inline-flex;
        width: 150px;
        height: 40px;
        align-items: center;
        .el-checkbox__input {
          .el-checkbox__inner {
            width: 20px;
            height: 20px;
            // background: rgba(234, 237, 240, 1);
            background: rgb(250, 250, 250);
            // border: 2px solid rgba(205, 207, 216, 1);
            border: 1px solid rgb(199, 199, 199);
            border-radius: 4px;
            box-sizing: border-box;
          }
        }
        .el-checkbox__input.is-checked {
          .el-checkbox__inner {
            background: #409eff;
            border-color: #409eff;
          }
          .el-checkbox__inner::after {//设置长期，选择框
            height: 10px;
            width: 4px;
            left:6px;
            border-width: 2px;
          }
        }
        .el-checkbox__label {
          // font-size: 22px;//原始
          font-size: 14px;  
          padding-left: 5px;
        }
      }
    }
  }
}

.self-datePick-required {
  .el-form-item__label:before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}

.self-datePick-changed {
  input.el-input__inner {
    // background: rgba(252, 230, 56, 0.2) !important;
  }
}

.self-datePick-showlong {
  .el-checkbox.is-bordered {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left-width: 0;
  }
}
.el-picker-panel {
  width: 340px;
  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      .el-date-picker__header {
        .el-picker-panel__icon-btn {
          font-size: 16px;
        }
      }
      .el-picker-panel__content {
        width: 310px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/datePickItem.vue